<template>
    <div class="main whites">
        <p class="legal_name plr10">{{legal_name}}</p>
        <div class="legalAccount_msg flex between plr10 hide">
          <div>
              <p class="ft12 msg_title">{{$t('asset.canuse')}}</p>
              <!-- <p v-if="legal_name=='BTC'||legal_name=='ETH'">{{legal_balance | toFixeds8}}</p> -->
              <p>{{legal_balance | toFixeds8}}</p>
          </div>
          <div>
              <p class="ft12 msg_title">{{$t('asset.frezz')}}</p>
              <!-- <p v-if="legal_name=='BTC'||legal_name=='ETH'">{{lock_legal_balance | toFixeds8}}</p> -->
              <p>{{lock_legal_balance| toFixeds8}}</p>
          </div>
          <div>
              <p class="ft12 msg_title">{{$t('asset.conversion')}}（USD）</p>
              <p>{{usdt_price | toFixeds}}</p>
          </div>
        </div>
        <div class="rec_wrap">
           <p class="rec_title flex between">
               <span>{{$t('asset.moneyRecord')}}</span>
               <!-- <span class="all">全部</span> -->
           </p>
           <p class="list_title flex">
               <span class="ft14">{{$t('td.num')}}</span>
               <span class="ft14 tc">{{$t('asset.record')}}</span>
               <span class="ft14 tr">{{$t('td.time')}}</span>
           </p>
           <ul class="log_list">
              <li class="flex arround ft12 flex around" v-for="(item,index) in list">
                  <span>{{item.value | toFixeds}}</span>
                  <!-- <span class="tc">{{item.info}}</span> -->
				  <span class="tc" v-if="reItem.en_info == 1">{{$t('song.jgsxf')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 2">{{$t('song.jgbj')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 3">{{$t('song.jgks')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 4">{{$t('song.jgyl')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 5">{{$t('song.htcz')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 6">{{$t('song.htshcz')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 7">{{$t('song.bbhr')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 8">{{$t('song.bbhc')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 9">{{$t('song.pccl')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 10">{{$t('song.gmsxf')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 11">{{$t('song.ggsxf')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 12">{{$t('song.ggbzj')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 13">{{$t('song.gbdj')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 14">{{$t('song.gbkc')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 15">{{$t('song.gsdj')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 16">{{$t('song.gskc')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 17">{{$t('song.tbsbjs')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 18">{{$t('song.tbsbch')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 19">{{$t('song.tbcg')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 20">{{$t('song.gyf')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 21">{{$t('song.gghr')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 22">{{$t('song.gghc')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 23">{{$t('song.tbdj')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 24">{{$t('song.tbkc')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 25">{{$t('song.mhxh')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 26">{{$t('song.mhhq')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 27">{{$t('song.msxf')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 28">{{$t('song.mbj')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 29">{{$t('song.mks')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 30">{{$t('song.myl')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 31">{{$t('song.mhr')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 32">{{$t('song.mhc')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 33">{{$t('song.sfsczj')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 34">{{$t('song.sfsckc')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 35">{{$t('song.sczj')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 36">{{$t('song.sckc')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 37">{{$t('song.scsy')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 38">{{$t('song.ahtcz')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 39">{{$t('song.xcbx')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 40">{{$t('song.bbjx')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 41">{{$t('song.bbth')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 42">{{$t('song.wtcd_t')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 43">{{$t('song.wtcd_b')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 44">{{$t('song.bxju_p')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 45">{{$t('song.bxju_s')}}</span>
				  <span class="tc" v-else-if="reItem.en_info == 46">{{$t('song.bxju_b')}}</span>
                  <span class="tr">{{item.created_time}}</span>
              </li>
           </ul>
           <p class="tc ft12 curPer mt20" @click="getMore()" v-if="more">{{$t('td.more')}}</p>
           <p class="tc ft12 curPer mt20" v-else>{{$t('td.nomore')}}</p>
        </div>
        <!-- <router-link tag="p" class="huazhuan" to='/transferLegal'>划转</router-link> -->
    </div>
</template>
<script>
export default {
    data(){
        return{
           currency:'',
           legal_name:'',
           legal_balance:'',
           lock_legal_balance:'',
           usdt_price:'',
           page:1,
           list:[],
           more:true
        }
    },
    filters: {
        toFixeds: function(value) {
            value = Number(value);
            return value.toFixed(4);
        },
        toFixeds8: function(value) {
            value = Number(value);
            return value.toFixed(8);
        }
    },
    created(){
       this.token = localStorage.getItem('token') || '';
       this.currency=this.$route.query.currency_id;

    },
    mounted(){
        this.init();
        this.legal_log();
    },
    methods:{
        init(){
            var that = this
            this.$http({
            url: '/api/' + 'wallet/detail',
            method:'post',
            data:{
                currency:that.currency,
                type:'legal'
            },
            headers: {'Authorization':  that.token}
            }).then(res=>{
                if(res.data.type  =='ok'){
                    var msg = res.data.message;
                    that.legal_name = msg.currency_name;
                    that.legal_balance = msg.change_balance;
                    that.lock_legal_balance = msg.lock_change_balance;
                    that.usdt_price = (msg.change_balance-0)*(msg.usdt_price);
                }else{
                    // layer.msg(res.message);
                }
            }).catch(error=>{
                console.log(error)
            })
        },
        legal_log(){
            var that = this
            this.$http({
            url: '/api/' + 'wallet/legal_log',
            method:'post',
            data:{
                currency:that.currency,
                type:1,
                page:that.page
            },
            headers: {'Authorization':  that.token}
            }).then(res=>{
                if(res.data.type  =='ok'){
                    var list = res.data.message.list;
                    if(list.length>0){
                        that.list=that.list.concat(list);
                    }else{
                        that.more=false;
                    }

                }else{
                    // layer.msg(res.message);
                }
            }).catch(error=>{
                console.log(error)
            })
        },
        getMore(){
            this.page=this.page+1;
            this.legal_log();
        }
    }
}
</script>
<style scoped>
   .legal_name{
       /* background: #1b1e2e; */
       padding: 5px 10px;
   }
    .msg_title{
        color: #61688a;
    }
   .main{
       /* color:#fff; */
       padding: 30px;
   }
   .legalAccount_msg{
       /* background: #1b1e2e; */
       padding: 6px 10px;
   }
   .legalAccount_msg div p:first-child{
       margin-bottom: 10px;
   }
   .rec_wrap{
       margin-top: 30px;
       margin-bottom: 30px;
   }
   .rec_title{
       margin-bottom: 10px;

   }
   .all{
        color: #61688a;
   }
   .list_title{
       padding: 10px;
       /* background: #1b1e2e; */
   }
   .list_title span{flex: 1}
   .huazhuan{
       text-align: center;
       margin-top: 60px;
       background: #7a98f7;
       padding: 8px;
   }
   .huazhuan:hover{
       cursor: pointer;
   }
   .log_list li{padding: 10px;}
   .log_list li span{flex: 1;}
</style>



// WEBPACK FOOTER //
// src/view/accounts/dealAccount.vue